import Navbar from "@/components/HomeNavBar/HomeNavBar.vue"
import AllPortals from "@/components/GetPortals/PortalsComponent.vue"
import CreateFeed from "@/components/CreateFeed/CreateFeed.vue"
import PortalMembers from "@/components/PortalMembers/PortalMembers.vue";
import PortalRequest from "@/components/GetPortalRequest/PortalRequestView.vue"
import SurveyView from "@/components/SurveysAndPolls/Survey.vue";
import DocumentApproval from "@/components/DocumentApproval/DocumentApproval.vue";
import DocumentWarehouse from "@/components/DocumentWarehouse/DocumentWarehouse.vue";
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue"

import {get_token } from "@/router";
export default {
     components:{
        Navbar,
        AllPortals,
        CreateFeed,
        PortalMembers,
        PortalRequest,
        SurveyView,
        DocumentApproval,
        DocumentWarehouse,
        StickyNav
     },
     data() {
      return {
         activeVoiceTab: 'your_feed',
         current_date: this.get_formatted_date(),
         reports:[],
         expandedReports: [],
         token_exists: false,
         edit_documents:[],
      };
     },
     mounted(){
      this.filterReports();
      this.token_exists = get_token();
     },
     methods: {
      getToken() {
      return get_token();
      },
      get_formatted_date() {
         const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
         return new Date().toLocaleDateString('en-GB', options);
      },
     filterReports() {

      const portal_id = this.$route.params.portal_id

      const payload = {
        filter_values: {
          portal_id: portal_id

        }
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/filter_reports_api/`,
        method: 'POST',
        headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {

          const status = response.status

          if(status === "success") {

            const reports=  response.data.report_data;
            this.fetchPostsByPortal(reports)
            setTimeout(() => {
              this.loading = false;
          }, 1000);
          }

        },
        complete: () => {
            this.isLoading = false;
        }
      });
    },
    fetchPostsByPortal(reports) {
      this.reports=[];
      this.reports = reports;
    },
    isImage(url) {
      return /\.(jpeg|jpg|gif|png|webp|bmp)$/i.test(url);
    },
    isPDF(url) {
      return /\.pdf$/i.test(url);
    },
    isVideo(url) {
      return /\.(mp4|webm|ogg)$/i.test(url);
    },
    isAudio(url) {
      return /\.(mp3|wav|ogg)$/i.test(url);
    },
    isDoc(url) {
      return /\.(doc|docx|ppt|pptx|xls|xlsx|html|htm)$/i.test(url);
   },
    toggle_description(reportId) {
      const index = this.expandedReports.indexOf(reportId);
      if (index > -1) {
        this.expandedReports.splice(index, 1);
      } else {
        this.expandedReports.push(reportId);
      }
    },
    get_description(report) {
      if (!report.description) return '';
      if (this.expandedReports.includes(report.id) || report.description.length <= 250) {
        return report.description;
      }
      return report.description.substring(0, 250) + '...';
    },
    delete_report(report_id) {
          if (!this.token_exists) {
            this.$router.push('/sign_in_finale');
            return;
          }
          Swal.fire({
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
              $.ajax({
                type: "DELETE",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_report_api/`,
                data: JSON.stringify({ report_id: report_id }),
                headers: {
                  'Authorization': `Token ${this.getToken()}`,
                  'Content-Type': 'application/json'
                },
                success: (response) => {
                  const status = response.status;
                  if (status === "success") {
                    this.reports = this.reports.filter(report => report.id !== report_id);
                    Swal.fire({
                      title: 'Deleted!',
                      text: 'The feed has been deleted.',
                      icon: 'success',
                      showConfirmButton: false,
                      timer: 1000
                    })
                  } else {
                    Swal.fire(
                      'Failed!',
                      response.message || 'An error occurred. Please try again.',
                      'error'
                    );
                  }
                },
                error: () => {
                  Swal.fire(
                    'Failed!',
                    'An error occurred. Please try again.',
                    'error'
                  );
                }
              });
            }
          });
    },
    add_report(newReport) {
    if (newReport) {
      if(newReport){
        this.reports.unshift(newReport);
      }
    }
    this.temporaryPost = null;
  },
   edit_report_data() {
            Swal.fire({
              title: 'Submitting...',
              text: 'Please wait while we process your request.',
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
            });
            this.isSubmitting = true;
            const formData = new FormData();
           this.report_description  =this.$refs.quillReportRef.getText()
            formData.append('description', this.report_description);
            formData.append('report_id', this.report_id);
            if (this.upload_media) {
              formData.append('file', this.upload_media);
            }
            if (this.audio_file) {
              formData.append('file', this.audio_file,this.audio_file_name);
            }
            if (this.selected_topic) {
              formData.append('topic_id', this.selected_topic);
            }
  
            $.ajax({
              type: 'POST',
              url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_report_api/`,
              data: formData,
              processData: false,
              contentType: false,
              headers: {
                'Authorization': `Token ${this.getToken()}`,
              },
              success: (response) => {
                if (response.status === 'success') {
                  const updatedReport = response.updated_data;
                  updatedReport.total_comments=updatedReport.total_comments||0
                  const reportIndex = this.reports.findIndex(
                    (hub) => hub.id === updatedReport.id
                  );
  
                  if (reportIndex !== -1) {
                    this.reports.splice(reportIndex, 1, updatedReport);
                  }
                  Swal.fire({
                    icon: 'success',
                    title: response.message,
                    showConfirmButton: false,
                    timer: 1000
                  }).then(() => {
                    $('#edit_report_modal').modal('hide');
                    this.edit_name = '';
                    this.edit_description = '';
                  });
                }
              },
              error: (response) => {
                Swal.close()
                const response_data = response.responseJSON;
                this.errors.edit_name=response_data.message
              },
              complete: () => {
                this.isSubmitting = false;
              }
            });
          },
    resetSelection(){
    this.editFileName='';
    this.edit_name='';
    this.edit_description='';
    this.edit_documents = [];
    this.edit_voice_id =null;
    this.edit_exchange_hub_id=null;

    this.editFileName='';
    this.edit_report_name= '',
    this.edit_report_id=null,
    this.edit_report_description='',

    this.upload_media='';
    this.audio_file = null;
    this.errors={}

  },
  onPortalChange() {
  if (this.selectedPortalId) {
    this.fecthTopics(this.selectedPortalId);
  }
},
  edit_report(report){
          const TextDescription = report.description.replace(/<[^>]*>/g, "");
          this.report_id=report.id
          this.edit_documents=report
          this.selectedPortalId = report.portal?.id || '';
          this.selected_topic=report.topic

          this.$nextTick(() => {
            if (this.$refs.quillReportRef) {
              const quillEditor = this.$refs.quillReportRef.getQuill();
              if (quillEditor) {
                quillEditor.setContents([
                  { insert:TextDescription || "" },
                ]);
              }
            }
          });
        },

        getFileIcon(fileUrl) {
          const iconMap = [
            { extensions: ['.pdf'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337946.png' },
            { extensions: ['.doc', '.docx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337932.png' },
            { extensions: ['.xls', '.xlsx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337958.png' },
            { extensions: ['.ppt', '.pptx'], icon: 'https://cdn-icons-png.flaticon.com/128/337/337950.png' },
            { extensions: ['.html', '.htm'], icon: 'https://cdn-icons-png.flaticon.com/128/732/732212.png' },
          ];
        
          for (const { extensions, icon } of iconMap) {
            if (extensions.some(ext => fileUrl.includes(ext))) {
              return icon;
            }
          }
        
          return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
        }        
,
  getFileName(fileUrl) {
    const decodedUrl = decodeURIComponent(fileUrl);
    const cleanUrl = decodedUrl.split('?')[0]; 
    return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
  },
}
}